import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
import { mapGetters } from 'vuex';
export default {
  name: 'Empty',
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }))
};